import styled from 'styled-components'
import { HUB_SIDEBAR_MOBILE_BREAKPOINT } from '../constants/breakpoints'

export { HUB_SIDEBAR_MOBILE_BREAKPOINT }
export const SIDEBAR_WIDTH_OPEN = '255px'
export const SIDEBAR_DRAWER_TRANSITION = 'transform 0.3s ease'

export const InnerPageRoot = styled.div.attrs({ className: 'zing-inner-page' })`
  position: relative;
`

export const SidebarBackdrop = styled.div<{ $visible: boolean }>`
  display: none;
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.colors.overlayTint};
  z-index: 55;
  transition: opacity 0.2s ease;

  @media screen and (max-width: ${HUB_SIDEBAR_MOBILE_BREAKPOINT}) {
    display: ${({ $visible }) => ($visible ? 'block' : 'none')};
  }
`

export const MobileSidebarCloseBar = styled.div<{ $open: boolean }>`
  display: none;

  @media screen and (max-width: ${HUB_SIDEBAR_MOBILE_BREAKPOINT}) {
    display: block;
    transform: ${({ $open }) => ($open ? 'translateX(0)' : 'translateX(-100%)')};
    transition: ${SIDEBAR_DRAWER_TRANSITION};
  }

  position: fixed;
  left: 0;
  top: 0;
  width: ${SIDEBAR_WIDTH_OPEN};
  max-width: 85vw;
  height: 52px;
  z-index: 61;
  pointer-events: none;
  box-sizing: border-box;
`

export const MobileSidebarCloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: max(8px, env(safe-area-inset-top, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  pointer-events: auto;
  background: transparent;
  color: ${({ theme }) => theme.colors.white};
  box-shadow: none;

  svg {
    width: 1.375rem;
    height: 1.375rem;
    color: inherit;
    fill: currentColor;
  }

  &:hover {
    filter: brightness(0.9);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.white};
    outline-offset: 2px;
  }
`

export const MobileHamburger = styled.button<{ $color?: string }>`
  display: none;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 1.25rem;
  border-radius: 4px;
  color: ${({ $color, theme }) => $color ?? theme.colors.grey600};
  flex-shrink: 0;
  order: -1;

  svg {
    color: inherit;
    fill: currentColor;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.grey50};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media screen and (max-width: ${HUB_SIDEBAR_MOBILE_BREAKPOINT}) {
    display: flex;
  }
`
